import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Soluciones',
  title: '¿Qué podemos construir para tu empresa?',
  subtitle:
    'Explora los problemas reales que resolvemos con tecnología. Cada solución combina IA, software e integraciones según lo que tu negocio necesita.',
  tags: ['Automatización', 'ERP', 'SaaS', 'IA', 'Modernización', 'Productos digitales'],
  blocks: [
    {
      icon: 'ri-flow-chart',
      title: 'Automatizar procesos',
      desc: 'Convierte tareas manuales y repetitivas en procesos automáticos.',
    },
    {
      icon: 'ri-git-merge-line',
      title: 'Conectar tu ERP',
      desc: 'Integra SAP Business One u otros sistemas con aplicaciones, APIs y servicios externos.',
    },
    {
      icon: 'ri-rocket-2-line',
      title: 'Crear un SaaS',
      desc: 'Transforma una idea o sistema interno en una plataforma comercial escalable.',
    },
    {
      icon: 'ri-brain-line',
      title: 'Incorporar IA',
      desc: 'Conecta agentes inteligentes con información y procesos reales de tu organización.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Modernizar sistemas',
      desc: 'Evoluciona aplicaciones antiguas hacia arquitecturas modernas.',
    },
    {
      icon: 'ri-box-3-line',
      title: 'Crear un producto digital',
      desc: 'Desde arquitectura y desarrollo hasta infraestructura y puesta en producción.',
    },
  ],
  highlightTitle: 'No vendemos horas. Construimos soluciones completas.',
  highlightDesc:
    'Partimos de tu problema de negocio y diseñamos la solución tecnológica que lo resuelve de principio a fin.',
};

export default function Soluciones() {
  return <ServicePage content={content} />;
}